/* lua.js generated code 0.3.0 */

var BottomButtonAnim = require("clover/panel/component/common/uiButtonAnims/HomeSceneBottomBtnAnim")
var ForumBtn = xClass("ForumBtn", function () {
    return cc.CSLoader.createNode("cocos/homeScene_faq_btn.csb")
})
ForumBtn.prototype.ctor = function () {
    let self = this
    self.init()
}
ForumBtn.prototype.init = function () {
    let self = this
    let bg = self.getChildByName("bg")
    let forumBtn = cc.Sprite.createWithSpriteFrameName("adapter/icon_forum.png")
    forumBtn.setPosition(0, 3)
    forumBtn.setAnchorPoint(0.47, 0.6)
    forumBtn.setScale(0.45)
    bg.removeFromParent()
    self.addChild(forumBtn, 1, "bg")
    let btn = UIButton.create(self, true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenFC))
    self.btn = btn
    self.btn.nodeExist = true
    self.isBusy = false
    // BottomButtonAnim.create(self.btn)
}
ForumBtn.prototype.onOpenFC = function () {
    var self = this
    self.btn.setEnabled(false)
    self.runAction(cc.Sequence.create(cc.DelayTime.create(2), cc.CallFunc.create(function () {
        if (self.btn.nodeExist) {
            self.btn.setEnabled(true)
        }
    })))
    function onFail() {
        Toast.make("打开兴趣部落错误，请重试！")
    }
    OpenFunscareLogic.openForum(0, null, null, onFail)
    DCAssist.dc4OpenModule(ModuleName.FORUM)
}
module.exports = ForumBtn
